import { Tag } from 'antd';
import InfoCard from 'common/ui/info-card';
import { Link } from 'react-router-dom';
import { investmentIdentificationImageTypeLabels } from 'utils/constants';
import { formatDateTime } from 'utils/formatDate';

const renderValue = value => {
  if (value === null || value === undefined || value === '') {
    return '-';
  }

  return value;
};

const formatKycResult = kycResult => {
  if (!kycResult) return '-';

  try {
    return JSON.stringify(JSON.parse(kycResult), null, 2);
  } catch (e) {
    return kycResult;
  }
};

const ItemDetail = ({ item }) => {
  const {
    user_id,
    user_email,
    user_name,
    image_type,
    kyc_provider,
    kyc_action_type,
    kyc_status,
    kyc_message,
    kyc_provider_image_id,
    is_passed_criteria,
    kyc_updated_at,
    created_at,
    kyc_result,
  } = item || {};

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <InfoCard
          label="User"
          value={
            user_id ? (
              <Link to={`/investment/users/${user_id}`}>
                {user_name ? `${user_name} (${user_email})` : user_email}
              </Link>
            ) : (
              '-'
            )
          }
        />
        <InfoCard
          label="Image Type"
          value={
            investmentIdentificationImageTypeLabels[image_type] ||
            renderValue(image_type)
          }
        />
        <InfoCard label="Provider" value={renderValue(kyc_provider)} />

        <InfoCard label="Action Type" value={renderValue(kyc_action_type)} />
        <InfoCard label="Status Code" value={renderValue(kyc_status)} />
        <InfoCard
          label="Passed Criteria"
          value={
            is_passed_criteria === true ? (
              <Tag color="green">{'Đạt'}</Tag>
            ) : is_passed_criteria === false ? (
              <Tag color="orange">{'Không đạt'}</Tag>
            ) : (
              '-'
            )
          }
        />

        <InfoCard
          label="KYC Updated At"
          value={kyc_updated_at ? formatDateTime(kyc_updated_at) : '-'}
        />
        <InfoCard
          label="Created At"
          value={created_at ? formatDateTime(created_at) : '-'}
        />
        <InfoCard
          label="Provider Image ID"
          value={renderValue(kyc_provider_image_id)}
        />

        <InfoCard
          className="md:col-span-3"
          label="Message"
          value={renderValue(kyc_message)}
        />
      </div>

      <InfoCard
        label="VNPT Payload"
        value={
          <pre className="whitespace-pre-wrap break-all font-mono text-xs bg-gray-50 p-3 rounded overflow-auto max-h-[600px]">
            {formatKycResult(kyc_result)}
          </pre>
        }
      />
    </div>
  );
};

export default ItemDetail;
